module.exports = __webpack_public_path__ + "static/media/Nornikel_main_t.491de09f.jpg";